import { DEFAULT_REDIRECT } from "@/constants/roles";
import router from "next/router";
import { isClient } from "../styles/utils";

const Index = (props) => {
  if (isClient()) {
    router.push(DEFAULT_REDIRECT);
  }

  return <></>;
};

export default Index;
